import { useEffect, useRef } from "react";
import { IMAGES } from "../../assets/media/images";
import "./CardInfo.scss";
import gsap from "gsap";

function CardInfo({ card, isRepeat, reward }) {
    const pageRef = useRef(null);

    useEffect(() => {
        if (pageRef.current) {
            gsap.fromTo(pageRef.current,
                {opacity: 0, y: -20},
                {opacity: 1, y: 0, duration: .6, ease: "power2.out"},
            );
        };
    }, []);

    return (
        <div className="card-info-wrapper" ref={pageRef}>
            <span className="title">Информация о карте</span>
            <div className="card-info">
                <span className="name">{card.name} {isRepeat && "[повторка]"}</span>
                <span>🗺️ Вселенная: {card.universe_name}</span>
                <span>⚜️ Редкость: {card.rare}</span>
                <span>🗡️ Атака: {card.attack}</span>
                <span>❤️ Здоровье: {card.health}</span>
                <span>💠 Ценность: {card.price}</span>
                {reward > 0 && <span className="reward">⭐️ Начислено осколков: +{reward}<img src={IMAGES.shards} alt="shards" /></span>}
            </div>
        </div>
    );
};

export default CardInfo;